import React, { useContext } from "react";
import { Tabs, Tab } from "@bloomberg/media-ui-core";
import styles from "./summary.module.css";
import PlaceholderImage from "~components/Placeholder";
import SectionTitle from "~components/SectionTitle";
import { QuoteContext } from "~context/QuoteContext";
import { showKeyStastistic } from "~utils";

export const SummaryPlaceholder = () => {
  const quoteData = useContext(QuoteContext);

  if (!quoteData) {
    return null;
  }

  return (
    <>
      <Tabs className={styles.charts} size="default" variant="basic">
        <Tab title="1D">
          <PlaceholderImage className={styles.snapshotChartPlaceholder} />
          <SectionTitle text="Overview" className={styles.overviewTitle} />
          <div className={styles.overview}>
            <PlaceholderImage className={styles.overviewPlaceholder} />
            <PlaceholderImage className={styles.overviewPlaceholder} />
            <PlaceholderImage className={styles.overviewPlaceholder} />
            <PlaceholderImage className={styles.overviewPlaceholder} />
            <PlaceholderImage className={styles.overviewPlaceholder} />
            <PlaceholderImage className={styles.overviewPlaceholder} />
          </div>
          {showKeyStastistic(quoteData) && (
            <>
              <SectionTitle
                text="Key Statistics"
                className={styles.keyStatisticsTitle}
              />
              <div className={styles.keyStatistics}>
                <PlaceholderImage className={styles.keyStatisticsPlaceholder} />
                <PlaceholderImage className={styles.keyStatisticsPlaceholder} />
                <PlaceholderImage className={styles.keyStatisticsPlaceholder} />
                <PlaceholderImage className={styles.keyStatisticsPlaceholder} />
                <PlaceholderImage className={styles.keyStatisticsPlaceholder} />
                <PlaceholderImage className={styles.keyStatisticsPlaceholder} />
                <PlaceholderImage className={styles.keyStatisticsPlaceholder} />
                <PlaceholderImage className={styles.keyStatisticsPlaceholder} />
                <PlaceholderImage className={styles.keyStatisticsPlaceholder} />
                <PlaceholderImage className={styles.keyStatisticsPlaceholder} />
              </div>
            </>
          )}
        </Tab>
        <Tab title="1M"> </Tab>
        <Tab title="6M"> </Tab>
        <Tab title="YTD"> </Tab>
        <Tab title="1Y"> </Tab>
        <Tab title="5Y"> </Tab>
      </Tabs>
    </>
  );
};
